import WomenStoriesSection from 'gatsby-theme-husky/src/components/WomenStoriesSection/WomenStoriesSection';

import './WomenStoriesSectionExtends.scss';

export default WomenStoriesSection;
